// extracted by mini-css-extract-plugin
export default {"fadeIn":"About_fadeIn__blSZh","visible":"About_visible__-wI-s"};